


















































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { Size } from "../../../../../../../base/domain/drawing";
import { SingleFlowLayoutSelector } from "../../../../../../../base/components/system/selectors";
import { DomainRegistry } from "../../../../../../domain";
import { IEditableFormatLayer, BackgroundImageCombination } from "../../../../../../domain/editableFormat";

@Component({
  components: {
    SingleFlowLayoutSelector,
  }
})
export default class BackgroundImageSelectDialog extends Mixins(DialogMixin) {
  confirmed: boolean;
  currentPageNumber: number = 0;
  pageCount: number = 0;
  selectableLayers: IEditableFormatLayer[] = [];
  layerCombination: BackgroundImageCombination[] = [];

  isLayerUnspecified(option: IEditableFormatLayer): boolean {
    return !option.imageGuid;
  }

  applyPageNumber(layer: IEditableFormatLayer): void {
    if (this.currentPageNumber !== 0 && this.pageCount === this.currentPageNumber) {
      return;
    }
    this.currentPageNumber += 1;
    this.layerCombination.push({ pageNumber: this.currentPageNumber, layer: layer });
  }

  toLabel(layer: IEditableFormatLayer): string {
    return this.layerCombination
      .filter(c => c.layer.imageGuid === layer.imageGuid)
      .map(o => o.pageNumber.toString())
      .join(", ");
  }

  clearSelectedLayers(): void {
    this.currentPageNumber = 0;
    this.layerCombination = [];
  }

  get isSelectedLayers(): boolean {
    return (this.layerCombination.length > 0);
  }

  get isLastPageSelected(): boolean {
    return (this.currentPageNumber === this.pageCount);
  }

  async show(layers: IEditableFormatLayer[], pageCount: number): Promise<BackgroundImageCombination[]> {
    return this.showModal(async () => {
      this.confirmed = false;
      this.clearSelectedLayers();
      this.applySelectableLayers(layers);
      this.pageCount = pageCount;
      await this.waitHidden();
      return this.confirmed ? this.layerCombination : null;
    });
  }

  applySelectableLayers(layers: IEditableFormatLayer[]): void {
    this.selectableLayers = [];
    this.selectableLayers = [
      {
        formatId: null as number,
        sectionNo: null as number,
        imageGuid: null,
        location: {
          x: 0,
          y: 0,
        },
        size: new Size(0, 0),
        fileName: "",
      }
    ];
    this.selectableLayers.push(...layers);
  }

  toImageStyle(value: IEditableFormatLayer): any {
    return value
      ? {
        width: "350px",
        height: "330px",
        backgroundImage: "url(" + this.toLayerSource(value) + ")",
      }
      : null;
  }

  private toLayerSource(layer: IEditableFormatLayer): string {
    if (!layer || !layer.imageGuid) {
      return null;
    }
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = layer.formatId
      ? repository.getLayerImageSource(layer.formatId, layer.imageGuid)
      : repository.getTemporaryImageSource(layer.imageGuid);
    return imageSource.source;
  }

  equivalentValidator(source: IEditableFormatLayer, destination: IEditableFormatLayer): boolean {
    return source === destination &&
      source.formatId === destination.formatId &&
      source.imageGuid === destination.imageGuid;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
